import { type IBaseWidget } from '../IBaseWidget.ts';
import { type IWidgetParsedProps } from '../repository/inputs/common/util/getWidgetProps.ts';
import { type IWidgetOption } from '../Widget.ts';
import { useBooleanCondition } from './useBooleanCondition.tsx';

/**
 * Hook per la gestione dell'editabilità di un widget.
 * Come per la visibilità, permette di gestire l'attivazione/disattivazione
 * di un widget non collegato al form/validatore.
 */
export function useWidgetEnabled(
  widget: IBaseWidget,
  options: IWidgetParsedProps,
) {
  return useBooleanCondition(widget.enabled, options);
}

/**
 * Gestisce l'abilitazione delle singole opzioni di un widget Select.
 */
export function useWidgetOptionEnabled(
  option: IWidgetOption | null | undefined,
  widgetOptions: Pick<IWidgetParsedProps, 'preview' | 'name'>,
) {
  return useBooleanCondition(
    option?.type === 'option' ? option.enabled : null,
    { ...widgetOptions, skip: !option || option?.type === 'divider' },
  );
}
